import React, { Component } from 'react'
import axios from 'axios';
import { APIURL } from '../../hoc/AxiosSetting/axios';


export default class ViewofLeadAuditorForm extends Component {
    constructor(props) {
        super(props)
        this.state = {
            id: props.match.params.id,
            data: {
                id: props.match.params.id,
            }
        }
    }
    componentDidMount() {
        axios.get(APIURL + '/api/competancy/get/competancydata/' + this.state.id)
            .then(res => {
                if (res.data.errorCode === 0) {
                    this.setState({ data: res.data.response })
                    console.log("res.data.response 19", res.data.response)
                }
            })
    }
    render() {
        return (
            <div>
                <div className="content-wrapper">
                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="card-body" style={{ paddingLeft: "50px" }}>
                                        <div className="row">
                                            <div className="col-sm-12">
                                                <div className="row">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Designation</label>
                                                    </div>
                                                    <div className="row mt-1">
                                                    <div className="col-sm-9">
                                                        <p>{this.state.data.designationName}</p>
                                                    </div>
                                                </div>
                                                <div className="row mt-3">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Nace Code(Main code)</label>
                                                    </div>
                                                    <div className="row mt-1">
                                                    <div className="col-sm-9">
                                                        <p>{this.state.data.nacemaincodeName}</p>
                                                    </div>
                                                </div>
                                                <div className="row mt-3">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Nace Code(Sub code)</label>
                                                </div>    
                                                <div className="row mt-1">
                                                    <div className="col-sm-9">
                                                        {
                                                            this.state.data && this.state.data.nacesubcode && this.state.data.nacesubcode.length>0 &&
                                                            this.state.data.nacesubcode.map((item,i) =>{
                                                                return(

                                                                  <li key={i}>{item.label}</li>
                                                         
                                                                )
                                                            })
                                                          
                                                        }
                                                        <li></li>
                                                    </div>
                                                </div>
                                                <div className="row mt-3">
                                                    <label htmlFor="staticEmail" className="col-sm-9 labelsize">Process & Product  Knowledge</label>
                                                </div>
                                                <div className="row mt-1">
                                                    <div className="col-sm-9">
                                                        {/* <p>{this.state.data.processproductknow}</p> */}
                                                        <div dangerouslySetInnerHTML={{ __html: this.state.data.processproductknow }} />
                                                    </div>
                                                </div>
                                                <div className="row mt-3">
                                                    <label htmlFor="staticEmail" className="col-sm-9 labelsize">Terminologies Used</label>
                                                    </div>
                                                <div className="row mt-1">
                                                    <div className="col-sm-9">
                                                        {/* <p>{this.state.data.terminologiesused}</p> */}
                                                        <div dangerouslySetInnerHTML={{ __html: this.state.data.terminologiesused }} />
                                                    </div>
                                                </div>
                                                <div className="row mt-3">
                                                    <label htmlFor="staticEmail" className="col-sm-9 labelsize">Technologies Known</label>
                                                    </div>
                                                <div className="row mt-1">
                                                    <div className="col-sm-9">
                                                        {/* <p>{this.state.data.technologiesknown}</p> */}
                                                        <div dangerouslySetInnerHTML={{ __html: this.state.data.technologiesknown }} />
                                                    </div>
                                                </div>
                                                <div className="row mt-3">
                                                    <label htmlFor="staticEmail" className="col-sm-9 labelsize">Other typical Practices</label>
                                                    </div>
                                                <div className="row mt-1">
                                                    <div className="col-sm-9">
                                                        {/* <p>{this.state.data.othertypicalpractices}</p> */}
                                                        <div dangerouslySetInnerHTML={{ __html: this.state.data.othertypicalpractices }} />
                                                    </div>
                                                </div>
                                                <div className="row mt-3">
                                                    <label htmlFor="staticEmail" className="col-sm-9 labelsize">Statutory & Regulatory Requirements</label>
                                                    </div>
                                                <div className="row mt-1">
                                                    <div className="col-sm-9">
                                                        {/* <p>{this.state.data.statutoryandregulatoryre}</p> */}
                                                        <div dangerouslySetInnerHTML={{ __html: this.state.data.statutoryandregulatoryre }} />
                                                    </div>
                                                </div>
                                                <div className="row mt-3">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Qualification</label>
                                                    </div>
                                                <div className="row mt-1">
                                                    <div className="col-sm-9">
                                                        {/* <p>{this.state.data.qualification}</p> */}
                                                        <div dangerouslySetInnerHTML={{ __html: this.state.data.qualification }} />
                                                    </div>
                                                </div>
                                                <div className="row mt-3">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Working Experience</label>
                                                    </div>
                                                <div className="row mt-1">
                                                    <div className="col-sm-9">
                                                        {/* <p>{this.state.data.workingexperience}</p> */}
                                                        <div dangerouslySetInnerHTML={{ __html: this.state.data.workingexperience }} />
                                                    </div>
                                                </div>
                                                <div className="row mt-3">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Audit Experience</label>
                                                    </div>
                                                <div className="row mt-1">
                                                    <div className="col-sm-9">
                                                        {/* <p>{this.state.data.auditexperience}</p> */}
                                                        <div dangerouslySetInnerHTML={{ __html: this.state.data.auditexperience }} />
                                                    </div>
                                                </div>
                                                <div className="row mt-3">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Evaluation method</label>
                                                    </div>
                                                <div className="row mt-1">
                                                    <div className="col-sm-9">
                                                        {/* <p>{this.state.data.evaluationmethod}</p> */}
                                                        <div dangerouslySetInnerHTML={{ __html: this.state.data.evaluationmethod }} />
                                                    </div>
                                                </div>
                                                <div className="row mt-3">
                                                    <label htmlFor="staticEmail" className="col-sm-3 labelsize">Risk level</label>
                                                    </div>
                                                <div className="row mt-1">
                                                    <div className="col-sm-9">
                                                        {/* <p>{this.state.data.risklevel}</p> */}
                                                        <div dangerouslySetInnerHTML={{ __html: this.state.data.risklevel }} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </section>
                </div>
            </div>
        )

    }
}